import React, { useEffect, useState } from 'react'
import {
  message,
  Skeleton,
  Form,
  Row,
  Col,
  Input,
  Button,
  Card,
  Typography,
  Table,
  Tooltip,
  Divider,
} from 'antd'
import Api from 'api'
import {
  useHistory,
  useParams,
} from 'react-router-dom/cjs/react-router-dom.min'
import { IoIosArrowBack } from 'react-icons/io'
import { useHardwareSelector } from 'store/hardwareSlice/hardwareReducer'
import { getHardwareList } from 'store/hardwareSlice/hardwareActions'
import { useDispatch } from 'react-redux'
import { orgMarkupValidation } from 'validations/OrgMarkUp'
import { EditFilled } from '@ant-design/icons'
const { Title } = Typography

function UpdateMarkup() {
  const [form] = Form.useForm()
  const [name, setName] = useState('')
  const [markUploading, setMarkUpLoading] = useState()
  const [btnLoading, setBtnLoading] = useState(false)
  const history = useHistory()
  const dispatch = useDispatch()
  const {
    loading: { fetchHardwareList },
    hardwareList,
  } = useHardwareSelector()
  const { id } = useParams()

  const getData = () => {
    dispatch(
      getHardwareList({
        onlyOrganization: true,
        organizationId: id,
      }),
    )
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setMarkUpLoading(true)
    Api.get(`/admins/get-organization-markups/${id}`)
      .then((res) => {
        const data = res?.results
        form.setFieldsValue({
          SMSMarkup: data.SMSMarkup && data.SMSMarkup,
          EmailMarkup: data.EmailMarkup && data.EmailMarkup,
          PaymentMarkup: data.PaymentMarkup && data.PaymentMarkup,
          FreeSMSQuota: data.FreeSMSQuota && data.FreeSMSQuota,
          FreeEmailQuota: data.FreeEmailQuota && data.FreeEmailQuota,
          PlatformSubscriptionCharges:
            data.PlatformSubscriptionCharges &&
            data.PlatformSubscriptionCharges,
          KioskMonthlyDues: data.KioskMonthlyDues && data.KioskMonthlyDues,
        })

        setMarkUpLoading(false)
      })
      .catch(() => {
        setMarkUpLoading(false)
        message.error('Something went wrong')
      })
    // eslint-disable-next-line
  }, [id, form, hardwareList])

  const handleSubmit = (payload) => {
    setBtnLoading(true)
    Api.put('/admins/update-organization-markups', payload)
      .then(() => {
        message.success('Markup Updated Successfully')
        setBtnLoading(false)
        getData()
        history.push('/organizations')
      })
      .catch(() => {
        message.error('Something went wrong')
        setBtnLoading(false)
      })
  }

  const onFinish = (values) => {
    const payload = {
      organizationId: id,
      smsMarkup: values.SMSMarkup,
      emailMarkup: values.EmailMarkup,
      paymentMarkup: values.PaymentMarkup,
      FreeSMSQuota: values.FreeSMSQuota,
      FreeEmailQuota: values.FreeEmailQuota,
      PlatformSubscriptionCharges: values.PlatformSubscriptionCharges,
    }

    handleSubmit(payload)
  }

  const handleBack = () => {
    history.goBack()
  }

  useEffect(() => {
    const url = window.location.href
    setName(getNameFromURL(url))
    // eslint-disable-next-line
  }, [name])

  const getNameFromURL = (url) => {
    const urlObj = new URL(url)
    const pathSegments = urlObj.pathname.split('/')
    const encodedName = pathSegments[pathSegments.length - 1]
    const decodedName = decodeURIComponent(encodedName)
    return decodedName
  }

  const columns = [
    {
      title: 'Device UUID',
      dataIndex: 'DeviceUUID',
      className: 'ant-table-row-cell-break-word t-w-[33.33%]',
    },
    {
      title: 'Device Name',
      dataIndex: 'DeviceName',
      className: 'ant-table-row-cell-break-word t-w-[33.33%]',
    },
    {
      title: 'Monthly Rate',
      dataIndex: 'MonthlyCost',
      className: 'ant-table-row-cell-break-word t-w-[33.33%]',
    },
    {
      dataIndex: 'DeviceUUID',
      className: 'ant-table-row-cell-break-word t-w-[33.33%]',
      render: (_, record) => (
        <Tooltip title="Edit">
          <EditFilled
            className="t-cursor-pointer t-text-secondary-100"
            style={{ fontSize: '1.5rem' }}
            onClick={() => {
              const url = `/hardware/add/${record?.OrganizationId}/${record?.Id}`
              window.open(`${url}`, '_blank')
            }}
          />
        </Tooltip>
      ),
    },
  ]

  return (
    <Card>
      <div>
        <Button
          type="primary"
          className="t-rounded-full t-flex t-items-center"
          onClick={handleBack}
          size="small"
        >
          <IoIosArrowBack />
          Back
        </Button>
        <Title level={4} className="t-mt-2">
          Cost Overrides for {name}
        </Title>
      </div>
      <Skeleton loading={markUploading} paragraph={{ rows: 12 }}>
        <Form
          form={form}
          layout="vertical"
          key={0}
          onFinish={onFinish}
          name="organization"
          scrollToFirstError
        >
          <Row gutter={[24, 0]}>
            <Col xl={12} md={12} xs={24} sm={24}>
              <Form.Item
                name="SMSMarkup"
                label="SMS Cost ($)"
                colon={false}
                rules={[orgMarkupValidation]}
              >
                <Input placeholder="Enter SMS Markup" />
              </Form.Item>
            </Col>
            <Col xl={12} md={12} xs={24} sm={24}>
              <Form.Item
                name="FreeSMSQuota"
                label="SMS Quota"
                colon={false}
                rules={[orgMarkupValidation]}
              >
                <Input placeholder="Enter free sms quota" />
              </Form.Item>
            </Col>

            <Col xl={12} md={12} xs={24} sm={24}>
              <Form.Item
                name="EmailMarkup"
                label="Email Charges ($)"
                colon={false}
                rules={[orgMarkupValidation]}
              >
                <Input placeholder="Enter Email Markup" />
              </Form.Item>
            </Col>
            <Col xl={12} md={12} xs={24} sm={24}>
              <Form.Item
                name="FreeEmailQuota"
                label="Email Quota"
                colon={false}
                rules={[orgMarkupValidation]}
              >
                <Input placeholder="Enter free email quota" />
              </Form.Item>
            </Col>

            <Col xl={24} md={24} xs={24} sm={24}>
              <Form.Item
                name="PaymentMarkup"
                label="Payment Markup ($)"
                colon={false}
                rules={[orgMarkupValidation]}
              >
                <Input placeholder="Enter Stripe Markup" />
              </Form.Item>
            </Col>
            <Col xl={24} md={24} xs={24} sm={24}>
              <Form.Item
                name="PlatformSubscriptionCharges"
                label="Platform Subscription Charges ($)"
                colon={false}
              >
                <Input placeholder="Enter platform subscription charges" />
              </Form.Item>
            </Col>
            <Divider />
            <Col xl={24} md={24} xs={24} sm={24}>
              <Title level={5}>Allocated Hardware List</Title>
            </Col>
            <Col xl={24} md={24} xs={24} sm={24}>
              <Skeleton
                loading={fetchHardwareList}
                active
                paragraph={{ rows: 6 }}
              >
                <Table
                  columns={columns}
                  dataSource={hardwareList || []}
                  tableLayout="auto"
                  scroll={{ x: 500 }}
                  bordered={false}
                  pagination={false}
                />
              </Skeleton>
            </Col>
            <Divider />
            <Col span={24} className="text-right">
              <Button
                loading={markUploading}
                type="primary"
                className="px-25"
                htmlType="submit"
              >
                {btnLoading ? 'Submit...' : 'Submit'}
              </Button>
            </Col>
          </Row>
        </Form>
      </Skeleton>
    </Card>
  )
}

export { UpdateMarkup }
